import { createContext } from "react";

/**
 * Gateway-agnostic status of the active payment driver, surfaced by the
 * driver's Provider and consumed by gateway-neutral form components (so they
 * don't reach into a specific driver's context).
 */
export type PaymentDriverStatus = {
  /** The active driver failed to initialise (e.g. a 3DS / SDK setup error). */
  error: Error | null;
  /** The active driver is still initialising its client SDK. */
  isLoading: boolean;
};

export const PaymentDriverStatusContext = createContext<PaymentDriverStatus>({
  error: null,
  isLoading: false,
});
